module.exports = __webpack_public_path__ + "img/manufacture@2x.3d1db42.webp";